var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0476 1.86673L11.381 3.20007C10.9893 3.27507 10.7143 3.61674 10.7143 4.01674V8.3334C10.7143 8.79174 11.0893 9.16674 11.5476 9.16674H18.2143C18.6726 9.16674 19.0476 8.79174 19.0476 8.3334V2.6834C19.0476 2.1584 18.5643 1.76673 18.0476 1.86673Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0476 18.1333L11.381 16.7999C10.9893 16.7249 10.7143 16.3832 10.7143 15.9832V11.6666C10.7143 11.2083 11.0893 10.8333 11.5476 10.8333H18.2143C18.6726 10.8333 19.0476 11.2083 19.0476 11.6666V17.3166C19.0476 17.8416 18.5643 18.2333 18.0476 18.1333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03928 3.7999L3.03928 4.85823C2.65595 4.94156 2.38097 5.28324 2.38097 5.6749V8.33324C2.38097 8.79157 2.75597 9.16657 3.2143 9.16657H8.2143C8.67263 9.16657 9.04763 8.79157 9.04763 8.33324V4.60824C9.04763 4.08324 8.55595 3.68324 8.03928 3.7999Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03928 16.1999L3.03928 15.1416C2.65595 15.0583 2.38097 14.7166 2.38097 14.3249V11.6666C2.38097 11.2083 2.75597 10.8333 3.2143 10.8333H8.2143C8.67263 10.8333 9.04763 11.2083 9.04763 11.6666V15.3916C9.04763 15.9166 8.55595 16.3166 8.03928 16.1999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsIcon);
export default __webpack_public_path__ + "static/media/windows-icon.f5379c87c87c0b84e7845a2e1add88a6.svg";
export { ForwardRef as ReactComponent };